/**
 * @module Utilities/Request
 * @desc Request helper funtions
 */

import type { RequestAction } from '../request.d';

import { contentTypes } from './content-types';

export function checkMissingParams(action: RequestAction) {
  const errors = [];

  if (!action.endpoint && !action.url) {
    errors.push('`an url` or `endpoint`');
  }

  if (action.type && !contentTypes[action.type]) {
    errors.push('`a valid type`');
  }

  if (errors.length) {
    throw new Error(`Error! You must pass ${errors.join(', ')}`);
  }

  return {
    ...action,
  };
}
